import { HorizontalContainer, VerticalContainer } from '@/components';
import { ChevronRightIcon } from '@/components/Icons';
import { ProfilePaths } from '@/features/profile/model/types';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { Link } from 'react-router';

type InsurancePartnerCardProps = {
    companyName?: string;
};

export const InsurancePartnerCard = ({
    companyName,
}: InsurancePartnerCardProps) => {
    const hasCoverage = Boolean(companyName);

    return (
        <VerticalContainer spacing="md" className="w-full">
            <h3 className="text-text-primary font-semibold">
                {R.Subscription}
            </h3>

            <div className="grid w-full grid-cols-1 items-stretch gap-4 lg:grid-cols-2">
                <Link
                    className="rounded-2xl border border-(--color-border-muted) px-4 py-6 hover:bg-(--color-bg-subtle)"
                    to={`/${hasCoverage ? ProfilePaths.InsurancePartnerDetails : ProfilePaths.SelectInsurancePartner}`}
                    aria-label={
                        hasCoverage
                            ? R.InsurancePartnerDetailsLabelA11y
                            : R.SelectInsurancePartnerLabelA11y
                    }
                >
                    <HorizontalContainer className="items-center justify-between">
                        <div className="overflow-hidden leading-tight font-bold text-ellipsis whitespace-nowrap text-(--color-text-heading)">
                            {companyName ?? R.SelectInsurancePartner}
                        </div>
                        <ChevronRightIcon aria-hidden="true" />
                    </HorizontalContainer>
                </Link>
            </div>
        </VerticalContainer>
    );
};
